import { Helmet } from 'react-helmet-async';
import Hero from './corporate-page/Hero'
import TajBusinessConnect from './corporate-page/TajBusinessConnect'
import Special from './corporate-page/Special'

import Conference from './corporate-page/Conference'
import Membership from './Membership'
import Testimonials from './partials/Testimonials'
export default function CorporatePage() {
 


   return (
      <>
         <Helmet>
            <title>Corporate Hall Near Delhi Airport | V Hotel The Grand Shob </title>

            <meta name="description" content="Host your meetings and events at V Hotel The Grand Shoba, featuring a modern corporate hall near Delhi Airport with top facilities and seamless services." />
            <meta name="keywords" content="Corporate Hall Near Delhi Airport" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://www.vhotelthegrandshoba.com/corporate"/>

         </Helmet>
         <div className="corporate-main">
            <Hero />
            <TajBusinessConnect />
            <Special />

            <Membership />
            <Conference />

            <Testimonials />
         </div>
      </>
   )
}
